import {
  MERCHANT_LIST_REQUEST,
  MERCHANT_LIST_SUCCESS,
  MERCHANT_LIST_FAILURE
} from '../../actions/merchantActions'

export default function reducer(
  state = {
    isFetching: false,
    isDeleting: false,
    data: {},
    errors: {},
    filters: {
      page: 1,
      search: '',
      type: [],
      credit: '',
      collection: '',
      only_billable: false,
      only_positive_balance: false
    },
    needRefresh: false,
    clientData: {},
    selected: {}
  },
  action
) {
  switch (action.type) {
    case MERCHANT_LIST_REQUEST:
      return Object.assign({}, state, {
        isFetching: true,
        needRefresh: false
      })

    case MERCHANT_LIST_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
        data: action.data
      })

    case MERCHANT_LIST_FAILURE:
      return Object.assign({}, state, {
        isFetching: false,
        errors: action.data
      })
    case 'UPDATE_CLIENT_FILTERS':
      return Object.assign({}, state, {
        filters: Object.assign({}, state.filters, action.data),
        needRefresh: true
      })
    default:
      return state
  }
}
